// @flow

import { catchEmptyBodyError, hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { bookmarkType } from '../../types';
import { addInstanceType } from '../../library/hitchpin_card/hitchpinCardFunctions';
import { CardInstanceType } from '../../components/Shared/HitchpinCard/CardInstanceType';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<bookmarkType>> =>
  hpfetch(`offerings/${id}/?wish=True`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<bookmarkType> =>
  hpfetch(`offerings/?wish=True&limit=${limit}&offset=${offset}`);

export const getWishlist = (limit: number = 100, offset: number = 0) => {
  return hpfetch(
    `offerings/?wish=True&limit=${limit}&offset=${offset}`,
  ).then(response =>
    addInstanceType(response, CardInstanceType.MyOfferingListing),
  );
};

export const deleteWishlistItemForOffering = (id: number) =>
  hpfetch(`offerings/${id}/wish/`, {
    method: 'DELETE',
  }).catch(catchEmptyBodyError);

export const addWishlistItemForOffering = (id: number) =>
  hpfetch(`offerings/${id}/wish/`, {
    method: 'PUT',
  });
